module.exports = __webpack_public_path__ + "img/ics_o_package-crrpic.e9c9c525.svg";